import { ModalsManager } from '@/components/modals/modalsManager';
import { MCPAddServerModal } from '@/features/mcp/MCPAddServerModal';
import { InstanceUrlModal } from '@/integrations/custom/instance-url-modal';

import { isSnowflakeMcpUrl, snowflakeMcpUrl } from './url';

import type { GuidedCustomMcpOffer } from '../guided-custom-mcp';

const SNOWFLAKE_MCP_DISPLAY_NAME = 'Snowflake';

async function connectSnowflake(): Promise<void> {
  const mcpUrl = await ModalsManager.showResolvable(InstanceUrlModal, {
    title: 'Snowflake MCP server',
    description:
      'Paste the URL of a Snowflake-managed MCP server. A Snowflake admin creates the server and an OAuth security integration for it.',
    label: 'MCP server URL',
    placeholder:
      'https://<account>.snowflakecomputing.com/api/v2/databases/<db>/schemas/<schema>/mcp-servers/<name>',
    invalidMessage:
      'Enter a URL like https://<account>.snowflakecomputing.com/api/v2/databases/<db>/schemas/<schema>/mcp-servers/<name>.',
    toMcpUrl: snowflakeMcpUrl,
  });
  if (!mcpUrl) return;

  ModalsManager.show(MCPAddServerModal, {
    initialName: SNOWFLAKE_MCP_DISPLAY_NAME,
    initialUrl: mcpUrl,
  });
}

export const snowflakeOffer: GuidedCustomMcpOffer = {
  id: 'snowflake',
  name: SNOWFLAKE_MCP_DISPLAY_NAME,
  description:
    'Query Snowflake data through Cortex Analyst, Cortex Search, and SQL.',
  icon: 'snowflakeBrand',
  categories: ['data_analytics'],
  searchText: 'snowflake data warehouse sql cortex mcp',
  isConnected: (servers) =>
    servers.some((server) => isSnowflakeMcpUrl(server.url)),
  connect: connectSnowflake,
};
